import React, { useState } from 'react';

import {
    Box,
    Typography,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
    TextField
} from "@mui/material";

const AssignmentMetricTask = ({ numWords, setNumWords, numMinutes, setNumMinutes, setActiveStep }) => {
    const [metricType, setMetricType] = useState(numMinutes > 0 ? 'minutes' : 'words');

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 2);
    };

    const handleMetricTypeChange = (event) => {
        setMetricType(event.target.value);
        setNumWords(0);
        setNumMinutes(0);
    };

    const handleMetricValueChange = (event) => {
        const value = parseInt(event.target.value, 10) || 0;
        if (metricType === 'words') {
            setNumWords(value);
        } else {
            setNumMinutes(value);
        }
    };

    const currentMetricValue = metricType === 'words' ? numWords : numMinutes;
    const step = metricType === 'words' ? 50 : 5;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 6 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h5" sx={{ flexGrow: 1 }}>Set Number of Words or Minutes</Typography>
            </Box>
            <Typography variant="body1" sx={{ mb: 7, pl: '100px', pr: '100px' }}>
                Assign the number of minutes or words to be read.
            </Typography>

            <RadioGroup
                value={metricType}
                onChange={handleMetricTypeChange}
                sx={{ justifyContent: 'center', mb: 5 }}
            >
                <FormControlLabel
                    value="words"
                    control={<Radio color="primary" />}
                    label="Number of words to read"
                />
                <FormControlLabel
                    value="minutes"
                    control={<Radio color="primary" />}
                    label="Minutes to read"
                />
            </RadioGroup>

            <TextField
                type="number"
                value={currentMetricValue}
                onChange={handleMetricValueChange}
                variant="outlined"
                inputProps={{ min: 0, step, style: { textAlign: 'right' } }}
                InputProps={{ endAdornment: <Typography variant="body1">{' '}{metricType}{'    '}</Typography> }}
                sx={{ width: '200px', mb: 5 }}
            />

            <Button
                variant="contained"
                color="primary"
                sx={{ mt: 3, mb: 2 }}
                onClick={handleNext}
                disabled={currentMetricValue === 0}
            >
              Continue
            </Button>
        </Box>
    );
};

export default AssignmentMetricTask;
